module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-SemiBoldItalic.c295f8dd.otf";